(() => {
  const roots = new Set();
  const pause = video => { if (!video.paused) video.pause(); };
  const pauseAll = except => roots.forEach(root => root.querySelectorAll('[data-it-media] video').forEach(video => {
    if (video !== except) pause(video);
  }));
  const init = root => {
    if (root.dataset.itMediaInit) return;
    root.dataset.itMediaInit = '1';
    roots.add(root);
    const cleanup = [];
    const listen = (target, type, handler, options) => {
      target.addEventListener(type, handler, options);
      cleanup.push(() => target.removeEventListener(type, handler, options));
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => { if (!entry.isIntersecting) pause(entry.target); });
    }, { threshold: .01 }) : null;
    root.querySelectorAll('[data-it-play]').forEach(button => { button.hidden = false; });
    listen(root, 'click', event => {
      const button = event.target.closest && event.target.closest('[data-it-play]');
      if (!button || !root.contains(button)) return;
      event.preventDefault();
      const media = button.closest('[data-it-media]');
      if (!media || !media.dataset.src || media.querySelector('video')) return;
      pauseAll();
      const video = document.createElement('video');
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'none';
      video.tabIndex = 0;
      video.muted = true;
      video.setAttribute('muted', '');
      video.loop = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      video.setAttribute('aria-label', media.dataset.label || '');
      if (media.dataset.poster) video.poster = media.dataset.poster;
      video.src = media.dataset.src;
      media.replaceChildren(video);
      video.focus({ preventScroll: true });
      try {
        const playing = video.play();
        if (playing && playing.catch) playing.catch(() => {});
      } catch (_) {}
      if (observer) observer.observe(video);
    });
    listen(root, 'play', event => {
      if (event.target.matches('[data-it-media] video')) pauseAll(event.target);
    }, true);
    listen(document, 'visibilitychange', () => {
      if (document.visibilityState === 'hidden') root.querySelectorAll('[data-it-media] video').forEach(pause);
    });
    listen(window, 'pagehide', () => root.querySelectorAll('[data-it-media] video').forEach(pause));
    root.itMediaCleanup = () => {
      root.querySelectorAll('[data-it-media] video').forEach(pause);
      cleanup.forEach(remove => remove());
      if (observer) observer.disconnect();
      roots.delete(root);
      delete root.dataset.itMediaInit;
      delete root.itMediaCleanup;
    };
  };
  const visit = (target, action) => {
    if (target.matches && target.matches('[data-ice-tiles-v2]')) action(target);
    target.querySelectorAll('[data-ice-tiles-v2]').forEach(action);
  };
  visit(document, init);
  document.addEventListener('shopify:section:load', event => visit(event.target, init));
  document.addEventListener('shopify:section:unload', event => visit(event.target, root => {
    if (root.itMediaCleanup) root.itMediaCleanup();
  }));
})();
